import {
  BranchesUrl,
  CompaniesUrl,
  DeparetmentsUrl,
  PartnersUrl,
  ProjectOwnersUrl,
} from '@/variables/Urls';

import { Country, State } from './CountryService';
import api from '@/utils/api';
import { AxiosResponse } from 'axios';
import { getCompanyId } from './AuthService';
import { Departement } from './DepartementService';

export interface ProjectOwner {
  name: string;
  id: string;
  companyId?: string;
}

export interface ProjectOwnersResponse {
  projectOwnerMOAs: ProjectOwner[];
  count: number;
}
const apiEndpoint = ProjectOwnersUrl;

export interface PaginatingParmas {
  takevalue?: number;
  fromvalue?: number;
  search?: string;
}
export async function getProjectOwners({
  fromvalue = 0,
  takevalue = 10,
  search = '',
}: PaginatingParmas) {
  let config = {
    params: {
      page: fromvalue,
      take: takevalue,
      search: search,
      companyId: getCompanyId(),
    },
  };
  const { data } = await api.get(apiEndpoint + '/Get', config);
  return data as ProjectOwnersResponse;
}

export async function getProjectOwner(Id: string) {
  const { data } = await api.get<ProjectOwner>(apiEndpoint + '/GetById', {
    params: { id: Id },
  });

  return data;
}

export async function saveProjectOwner(projectOwner: ProjectOwner) {
  if (projectOwner.id) {
    const body = { ...projectOwner };

    const response = await api.put(apiEndpoint + '/put', body);
    return response;
  }

  const response_1 = await api.post(apiEndpoint + '/post', projectOwner);
  return response_1;
}

export function deleteProjectOwner(Id: string) {
  return api
    .delete(apiEndpoint + '/delete', { data: { id: Id } })
    .then((responce) => {
      return responce;
    })
    .catch((error) => {
      return error;
    });
}
